export enum damageReportReasons {
  vehicleNotReadyForDriving = 'vehicleNotReadyForDriving',
  personalInjury = 'personalInjury',
  otherReason = 'otherReason',
}
